import {
  put, takeLatest, call, all, fork, select,
} from 'redux-saga/effects';
import {
  forEach, chain, map,
} from 'lodash';
import {
  FETCH_FAVORITE,
  FETCH_FAVORITE_DETAIL,
  CREATE_FAVORITE,
  REMOVE_FAVORITE,
} from '../actions/favorite/action_types';

import actions from '../actions/favorite';
import rf from '../../requests/RequestFactory';

function* fetchFavorite(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('FavoriteRequest').fetchAffiliate(params), action.params);
    yield put(actions.fetchFavoriteSucceed(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchFavoriteDetail(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('FavoriteRequest').fetchAffiliateDetail(params), action.params);

    yield put(actions.fetchFavoriteDetailSucceed(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* createFavorite(action) {
  try {
    const { data } = yield call((data) => rf.getRequest('FavoriteRequest').createAffiliate(data), action.data);
    yield put(actions.fetchFavorite(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* deleteFavorite(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('FavoriteRequest').deleteAffiliate(params), action.params);
    yield put(actions.fetchFavorite(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* watchFavorite() {
  yield takeLatest(FETCH_FAVORITE, fetchFavorite);
  yield takeLatest(FETCH_FAVORITE_DETAIL, fetchFavoriteDetail);
  yield takeLatest(CREATE_FAVORITE, createFavorite);
  yield takeLatest(REMOVE_FAVORITE, deleteFavorite);
}

export default function* rootSaga() {
  yield all([fork(watchFavorite)]);
}
